import React from "react";
import { Container, Image, Row, Col } from "react-bootstrap";
import Author from "../assests/sb.jpg";
import { Link } from "react-router-dom";

function Footer() {
  const footerStyle = {
    width: "100%",
    borderTop: "1px solid var(--border-color)",
    background: "var(--card-bg)",
    padding: "50px 0 30px",
    marginTop: "80px",
    boxShadow: "0 -2px 10px rgba(0, 0, 0, 0.05)"
  };

  const textStyle = {
    marginLeft: "10px",
  };

  const linkStyle = {
    textDecoration: "none",
    color: "inherit",
    transition: "all 0.3s ease",
    padding: "4px 0",
    display: "inline-block"
  };

  const listItemStyle = {
    marginBottom: "10px",
  };

  return (
    <div style={footerStyle}>
      <Container>
        <Row className="align-items-center">
          <Col xs={12} md={6} className="text-center text-md-left mb-4 mb-md-0">
            <div className="d-flex flex-column align-items-center align-items-md-start">
              <Image
                src={Author}
                roundedCircle
                style={{
                  borderRadius: "50%",
                  width: "90px",
                  height: "90px",
                  objectFit: "cover",
                  border: "3px solid var(--primary-color)",
                  boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)"
                }}
              />
              <h4 style={textStyle}>Subin's Storyboard</h4>
            </div>
            <p className="mt-3">
              Explore the diverse tapestry of life with Subin's Storyboard. From
              coding conquests to travel tales and beyond, join me on a journey
              through captivating experiences and valuable insights. Stay
              connected for more enriching stories and adventures.
            </p>
          </Col>
          <Col xs={12} md={6}>
            <Row>
              <Col xs={6} className="text-center text-md-left">
                <h4>Links</h4>
                <ul style={{ listStyle: "none", padding: 0 }}>
                  <li style={listItemStyle}>
                    <Link to="/" style={linkStyle}>
                      Home
                    </Link>
                  </li>
                  <li style={listItemStyle}>
                    <Link to="/admin" style={linkStyle}>
                      Admin
                    </Link>
                  </li>
                  <li style={listItemStyle}>
                    <Link to="/login" style={linkStyle}>
                      Login
                    </Link>
                  </li>
                </ul>
              </Col>
              <Col xs={6} className="text-center text-md-left">
                <h4>Contact</h4>
                <ul style={{ listStyle: "none", padding: 0 }}>
                  <li style={listItemStyle}>
                    <a
                      href="https://subeen9-github-io.vercel.app/"
                      style={linkStyle}
                    >
                      Subin's Site
                    </a>
                  </li>
                  <li style={listItemStyle}>
                    <a
                      href="https://www.linkedin.com/in/subin-bista-/"
                      style={linkStyle}
                    >
                      Linkedin
                    </a>
                  </li>
                  <li style={listItemStyle}>
                    <a
                      href="https://www.youtube.com/channel/UC52b7k_geBk6NwcqJLvsdGA"
                      style={linkStyle}
                    >
                      Youtube
                    </a>
                  </li>
                </ul>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Footer;
